import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20luxury%20home%20theater%20with%20large%20curved%20screen%20displaying%20vibrant%20cinematic%20imagery%2C%20warm%20ambient%20lighting%20with%20coral%20and%20gold%20accents%2C%20plush%20red%20velvet%20seats%2C%20premium%20entertainment%20atmosphere%2C%20photorealistic%20interior%20design%2C%20cinematic%20composition&width=1920&height=800&seq=hero-bg-2026&orientation=landscape"
          alt="红桃视频网页版 - 在线高清视频平台"
          className="w-full h-full object-cover object-top"
          title="红桃视频网页版 - 免费在线观看高清视频"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
            海量高清视频，免费在线观看
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
            无需下载安装，打开浏览器即可畅享。PC端、手机端均可流畅播放，内容丰富，更新及时，是您娱乐休闲的首选视频平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-8 py-3.5 rounded-full font-semibold text-base transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-xl"></i>
              开始观看
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white px-8 py-3.5 rounded-full font-medium text-base transition-all duration-200 whitespace-nowrap border border-white/30"
            >
              <i className="ri-information-line text-xl"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}